import {  t  } from "@/client/libs/dummy-i18n";
import { CrownIcon, LockIcon } from "@phosphor-icons/react";
import { AspectRatio } from "@stackmorph/ui";
import { cn, premiumTemplates, templatesList } from "@stackmorph/utils";
import { motion } from "framer-motion";
import { useState } from "react";

import { UpgradeModal } from "@/client/components/upgrade-modal";
import { useUser } from "@/client/services/user";
import { useResumeStore } from "@/client/stores/resume";

import { SectionIcon } from "../shared/section-icon";

export const TemplateSection = () => {
  const { user } = useUser();
  const setValue = useResumeStore((state) => state.setValue);
  const currentTemplate = useResumeStore((state) => state.resume.data.metadata.template);
  
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  const isPremium = user?.isPremium;

  return (
    <>
      <section id="template" className="grid gap-y-6">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-x-4">
            <SectionIcon id="template" size={18} name={t`Template`} />
            <h2 className="line-clamp-1 text-2xl font-bold lg:text-3xl">{t`Template`}</h2>
          </div>
        </header>

        <main className="grid grid-cols-2 gap-8 @lg/right:grid-cols-3 @2xl/right:grid-cols-4">
          {templatesList.map((template, index) => {
            const isLocked = premiumTemplates.includes(template) && !isPremium;

            return (
              <AspectRatio key={template} ratio={1 / 1.4142}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { delay: index * 0.1 } }}
                  whileTap={{ scale: 0.98, transition: { duration: 0.1 } }}
                  className={cn(
                    "relative cursor-pointer rounded-sm ring-primary transition-all hover:ring-2",
                    currentTemplate === template && "ring-2",
                    isLocked && "opacity-80 grayscale-[0.5]"
                  )}
                  onClick={() => {
                    if (isLocked) {
                      setIsUpgradeModalOpen(true);
                    } else {
                      setValue("metadata.template", template);
                    }
                  }}
                >
                  <img src={`/templates/jpg/${template}.jpg`} alt={template} className="rounded-sm" />

                  {isLocked && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/40 backdrop-blur-[1px]">
                      <div className="rounded-full bg-yellow-500 p-2 text-white shadow-lg">
                        <LockIcon size={20} weight="fill" />
                      </div>
                    </div>
                  )}

                  <div className="absolute inset-x-0 bottom-0 h-32 w-full bg-gradient-to-b from-transparent to-background/80">
                    <p className="absolute inset-x-0 bottom-2 flex items-center justify-center gap-1 text-center font-bold capitalize text-primary">
                      {template}
                      {premiumTemplates.includes(template) && (
                        <CrownIcon size={12} weight="fill" className="text-yellow-500" />
                      )}
                    </p>
                  </div>
                </motion.div>
              </AspectRatio>
            );
          })}
        </main>
      </section>

      <UpgradeModal
        isOpen={isUpgradeModalOpen}
        trigger="template"
        onClose={() => {
          setIsUpgradeModalOpen(false);
        }}
      />
    </>
  );
};
